module.exports = __webpack_public_path__ + "static/media/4.0daba61e.png";